$(() => {
  const generateDropdown = ($controlGroup) => {
    const monthNames = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];
    const qntYears = 90;
    const selectYear = $controlGroup.parent().find(".year");
    const selectMonth = $controlGroup.parent().find(".month");
    const selectDay = $controlGroup.parent().find(".day");
    let currentYear = new Date().getFullYear();

    for (let y = 0; y < qntYears; y += 1) {
      const yearElem = document.createElement("option");
      yearElem.value = currentYear;
      yearElem.textContent = currentYear;
      selectYear.append(yearElem);
      currentYear -= 1;
    }

    for (let m = 0; m < 12; m += 1) {
      const month = monthNames[m];
      const monthElem = document.createElement("option");
      monthElem.value = m + 1;
      monthElem.textContent = month;
      selectMonth.append(monthElem);
    }

    for (let d = 1; d <= 31; d += 1) {
      const dayElem = document.createElement("option");
      dayElem.value = d;
      dayElem.textContent = d;
      selectDay.append(dayElem);
    }
  };

  const applyDOBStyle = (options) => {
    $(".date-of-birth input").each(function () {
      const $controlGroup = $(this);
      const { name } = $controlGroup[0];
      const pDate = $(this).val();
      const format = $controlGroup[0].attributes["data-date-format"].value;
      const [field1, field2] =
        format === "en-US" ? ["month", "day"] : ["day", "month"];

      $($controlGroup.parent()).prepend(`
        <div class="${field1}-wrapper select-wrapper">
            <select class="${field1} required validator-ignore" name="${name}_${field1}">
                <option value="0">${field1}</option>
            </select>
        </div>
        <div class="${field2}-wrapper select-wrapper">
            <select class="${field2} required validator-ignore" name="${name}_${field2}">
                <option value="0">${field2}</option>
            </select>
        </div>
        <div class="year-wrapper select-wrapper">
            <select class="year required validator-ignore" name="${name}_year">
                <option value="0">Year</option>
            </select>
        </div>`);
      generateDropdown($controlGroup);
      $controlGroup.addClass("hiddenInput");
      const ageTest = function (dob) {
        const date = new Date(dob);
        const yesterday = new Date();
        yesterday.setDate(yesterday.getDate() - 1);
        const age = Math.floor(
          (yesterday - date) / (365.25 * 24 * 60 * 60 * 1000),
        );

        return age > 17 && age < 75;
      };
      const validateAge = function (dob) {
        if (options.hcpValidate) {
          if (!ageTest(dob)) {
            $($controlGroup.parent().find("input")).val("");
          }
        }
        $(".questionnaire form")
          .validate()
          .element($($controlGroup.parent().find("input")));
      };

      const dob = pDate.split("/");
      const day = format === "en-US" ? dob[1] : dob[0];
      const month = format === "en-US" ? dob[0] : dob[1];
      const year = dob[2];
      const date = `${year}/${month}/${day}`;
      const $dayElm = $controlGroup.parent().find(".day");
      const $monthElm = $controlGroup.parent().find(".month");
      const $yearElm = $controlGroup.parent().find(".year");

      if (day && year && month) {
        $($dayElm).val(parseInt(day, 10).toString());
        $($monthElm).val(parseInt(month, 10).toString());
        $($yearElm).val(year);
        validateAge(date);
      }
      $($controlGroup.parent().find("select")).on("change", function () {
        const day = $($dayElm).val();
        const month = $($monthElm).val();
        const year = $($yearElm).val();
        const dob =
          format === "en-US"
            ? `${month}/${day}/${year}`
            : `${day}/${month}/${year}`;
        const $input = $controlGroup.parent().find("input");

        if (day !== "0" && year !== "0" && month !== "0") {
          $($input).val(dob);
          const date = `${year}/${month}/${day}`;
          validateAge(date);
        } else {
          $($input).val("");
        }
        // Trigger change event on input to publish form_question_answered event
        $input.change();
      });
    });
  };

  $(document).ready(function () {
    if ($(".date-of-birth").length > 0) {
      const hcpValidate = $(".date-of-birth").hasClass("hcp-validate");
      applyDOBStyle({ hcpValidate });
    }
  });
});
